import { render } from "./CompanyScenes.vue?vue&type=template&id=6df6b5ce&ts=true"
import script from "./CompanyScenes.vue?vue&type=script&lang=ts"
export * from "./CompanyScenes.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./CompanyScenes.vue?vue&type=style&index=0&id=6df6b5ce&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__